import qs from 'qs';

function hasRel(linkObject) {
    return linkObject && linkObject.rel;
}

function intoRels(accumulator, linkObject) {
    linkObject.rel.split(/\s+/).forEach((rel) => {
        accumulator[rel] = { ...linkObject, rel };
    });
    return accumulator;
}

function createObjects(accumulator, part) {
    const match = part.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
    if (match) {
        accumulator[match[1]] = match[2];
    }
    return accumulator;
}

function parseQueryString(url) {
    const queryString = url.split('?')[1] || '';
    return qs.parse(queryString);
}

function parseLink(link) {
    try {
        const match = link.match(/<?([^>]*)>(.*)/);
        const linkUrl = match[1];
        const parts = match[2].split(';');
        const queryParameters = parseQueryString(linkUrl);

        parts.shift();

        const info = parts.reduce(createObjects, {});
        return { ...queryParameters, ...info, url: linkUrl };
    } catch {
        return null;
    }
}

export default function parseLinkHeader(linkHeader) {
    if (!linkHeader) {
        return null;
    }

    return linkHeader.split(/,\s*</).map(parseLink).filter(hasRel).reduce(intoRels, {});
}
